import React, {FC, useEffect, useRef, useState} from "react";
import cls from "../../shared/products/product.module.scss"
import {TranslationsType} from "../../../types/homePageTypes";
import CustomDetailItem from "./CustomDetailItem";

interface ICustomDetails {
    details: Array<{
        attribute_name: string;
        attribute_value: string;
        text_value: string | null;
        boolean_value: string | null;
        attribute: Array<{ type: string }>
    }>;
    isSelectDetail: boolean;
    showDetailsInFront: boolean;
    dbName: string;
    domain: string;
    translationsData: TranslationsType;
}

const CustomDetails: FC<ICustomDetails> = (
    {
        details,
        isSelectDetail,
        domain,
        dbName,
        showDetailsInFront,
        translationsData
    }
) => {
    return (
        <div className={cls["details_block"]}>
            {details.map((
                detail: any, index: number
            ) => {
                return <CustomDetailItem
                    key={index}
                    detail={detail}
                    domain={domain}
                    dbName={dbName}
                    showDetailsInFront={showDetailsInFront}
                    translationsData={translationsData}
                />
            })}
        </div>
    )

};

export default CustomDetails;